import React, { useState } from 'react';
import { TooltipContainer, Tooltip } from './StyledComponents';

interface TooltipWrapperProps {
  children: React.ReactNode;
  tooltipText?: string;
  showTooltip?: boolean;
}

const TooltipWrapper: React.FC<TooltipWrapperProps> = ({ 
  children, 
  tooltipText, 
  showTooltip = false 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!showTooltip || !tooltipText) {
    return <>{children}</>;
  }

  return (
    <TooltipContainer
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && <Tooltip>{tooltipText}</Tooltip>}
    </TooltipContainer>
  );
};

export default TooltipWrapper;
